import { BreadcrumbGroup, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import CachedMessageDetails from "@/components/cached-messages/CachedMessageDetails";

const AdminCachedMessageDetailsPage: React.FC = () => {
  const { messageId } = useParams();
  const navigate = useNavigate();

  if (!messageId) {
    return <Navigate to="/admin/cached-messages" replace />;
  }

  return (
    <SpaceBetween size="s">
      <BreadcrumbGroup
        items={[
          { text: "Cached Messages", href: "/admin/cached-messages" },
          { text: `${messageId}`, href: "" },
        ]}
        onClick={(e) => {
          // Used to avoid reload.
          e.preventDefault();
          navigate(e.detail.href);
        }}
        ariaLabel="Breadcrumbs"
      />
      <CachedMessageDetails messageId={messageId} />
    </SpaceBetween>
  );
};

export default AdminCachedMessageDetailsPage;
